
import React from 'react';
import AnimateInView from '@/components/ui/animate-in-view';

const FibreHero = () => {
  return (
    <section className="bg-forti-fi-teal py-20 px-4" aria-labelledby="fibre-heading">
      <div className="container mx-auto max-w-4xl text-center">
        <AnimateInView animation="fade-in">
          <h1 id="fibre-heading" className="text-white mb-6">
            Beneath It All, Maximum Protection
          </h1>
          <p className="text-white/90 text-xl md:text-2xl mb-8">
            Buried. Unseen. Unbreakable. The Future of Perimeter Defense.
          </p>
        </AnimateInView>
      </div>
    </section>
  );
};

export default FibreHero;
